import qs from 'qs';
import request from '../utils/request';

// 添加站点
export const createStation = (data) => request({
  url: '/admin/station',
  method: 'post',
  data,
});
// 站点列表
export const stationList = (param) => request(`/admin/station?${qs.stringify(param)}`);
// 站点详情
export const stationDetail = (id) => request(`/admin/station/${id}`);
// 获取站点二维码配置
export const stationQrcodeConfig = (id) => request(`/admin/station/qrcode/wx/${id}`);
// 站点修改
export const stationModify = (id, data) => request({
  url: `/admin/station/${id}`,
  method: 'put',
  data,
});
// 发送站点命令
export const runCmd = (id, cmd) => request({
  url: `/admin/station/run-cmd/${id}/${cmd}`,
  method: 'put',
});
// 获取数据对接配置
export const dataConnectConfig = (id) => request(`/admin/station/dataconnect/config/${id}`);
// 数据对接
export const setdataConnect = ({ id, status, excom }) => request({
  method: 'put',
  url: `/admin/station/data-connect/${id}`,
  data: {
    status,
    excom,
  },
});
// 获取站点柜子组数
export const stationCabnums = (stationId) => request(`/admin/station/station-cabnum/${stationId}`);
// 获取dtu日志
export const dtulog = (param) => request(`/admin/dtulog?${qs.stringify(param)}`);
// 剔除链接
export const removeDtuConnect = (id) => request({
  url: `/admin/dtulog/remove-connect/${id}`,
  method: 'put',
});
// 站点地图
export const stationMap = () => request('/admin/station-map');
// dtu状态检查
export const dtucheck = (id) => request(`/admin/station/dtu-check/${id}`);
// 主板检查
export const mainboardcheck = (id, cabnum) => request(`/admin/station/mainboard-check/${id}/${cabnum}`);
// 开箱并检测
export const checAllCabinet = (id) => request(`/admin/station/cabinet-open-all/${id}`);
// 灯光控制
export const lightControl = (id, light) => request({
  url: `admin/station/lightcontrol/${id}/${light}`,
  method: 'put',
});
// 灯光控制
export const exchangeDevice = (id) => request({
  url: `admin/station/exchange-device/${id}`,
  method: 'put',
});
